<template>
    <div class="about-kf">
        <!-- <p class="indent">Alcomet AD is one of the leading manufacturers of rolled and extruded aluminium products in the Balkans and the only one of its kind in Bulgaria to house the production of both types of products. Benefitting from over 35 years of experience in the field of nonferrous metallurgy, today we offer a large variety of foils, sheets, strips and profiles with a total turnover exceeding 168 mln EUR.</p> -->
        <div class="info-circles">
            <div class="info-circle">
                <div class="alcomet info-circle-icon">l</div>
                <svg width="164" height="164" xmlns="http://www.w3.org/2000/svg">
                    <g>
                    <rect fill="none" id="canvas_background" height="166" width="166" y="-1" x="-1"/>
                    <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
                    <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%" width="100%"/>
                    </g>
                    </g>
                    <g>
                    <path class="circle-path" id="svg_2" d="m7,82c0,-41.43646 33.56354,-75 75,-75c41.43646,0 75,33.56354 75,75c0,41.43646 -33.56354,75 -75,75c-41.43646,0 -75,-33.56354 -75,-75z" stroke-opacity="null" stroke-linecap="null" stroke-linejoin="null" stroke-width="14" stroke="rgb(51, 108, 157)" fill-opacity="null" fill="none"/>
                    </g>
                </svg>
                <div v-scroll-reveal class="info-circle-text">
                    <h3>1981г</h3>
                    <p>Основаване<br/>на компанията</p>
                </div>
            </div>
            <div class="info-circle">
                <div class="alcomet info-circle-icon">m</div>
                <svg width="164" height="164" xmlns="http://www.w3.org/2000/svg">
                    <g>
                    <rect fill="none" id="canvas_background" height="166" width="166" y="-1" x="-1"/>
                    <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
                    <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%" width="100%"/>
                    </g>
                    </g>
                    <g>
                    <path class="circle-path" id="svg_2" d="m7,82c0,-41.43646 33.56354,-75 75,-75c41.43646,0 75,33.56354 75,75c0,41.43646 -33.56354,75 -75,75c-41.43646,0 -75,-33.56354 -75,-75z" stroke-opacity="null" stroke-linecap="null" stroke-linejoin="null" stroke-width="14" stroke="rgb(51, 108, 157)" fill-opacity="null" fill="none"/>
                    </g>
                </svg>
                <div v-scroll-reveal class="info-circle-text">
                    <h3>370К м<sup>2</sup></h3>
                    <p>Площ</p>
                </div>
            </div>
            <div class="info-circle">
                <div class="alcomet info-circle-icon">n</div>
                <svg width="164" height="164" xmlns="http://www.w3.org/2000/svg">
                    <g>
                    <rect fill="none" id="canvas_background" height="166" width="166" y="-1" x="-1"/>
                    <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
                    <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%" width="100%"/>
                    </g>
                    </g>
                    <g>
                    <path class="circle-path" id="svg_2" d="m7,82c0,-41.43646 33.56354,-75 75,-75c41.43646,0 75,33.56354 75,75c0,41.43646 -33.56354,75 -75,75c-41.43646,0 -75,-33.56354 -75,-75z" stroke-opacity="null" stroke-linecap="null" stroke-linejoin="null" stroke-width="14" stroke="rgb(51, 108, 157)" fill-opacity="null" fill="none"/>
                    </g>
                </svg>
                <div v-scroll-reveal class="info-circle-text">
                    <h3>1215</h3>
                    <p>Служители</p>
                </div>
            </div>
        </div>
        <div class="info-circles">
            <div class="info-circle">
                <div class="alcomet info-circle-icon">o</div>
                <svg width="164" height="164" xmlns="http://www.w3.org/2000/svg">
                    <g>
                    <rect fill="none" id="canvas_background" height="166" width="166" y="-1" x="-1"/>
                    <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
                    <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%" width="100%"/>
                    </g>
                    </g>
                    <g>
                    <path class="circle-path" id="svg_2" d="m7,82c0,-41.43646 33.56354,-75 75,-75c41.43646,0 75,33.56354 75,75c0,41.43646 -33.56354,75 -75,75c-41.43646,0 -75,-33.56354 -75,-75z" stroke-opacity="null" stroke-linecap="null" stroke-linejoin="null" stroke-width="14" stroke="rgb(51, 108, 157)" fill-opacity="null" fill="none"/>
                    </g>
                </svg>
                <div v-scroll-reveal class="info-circle-text">
                    <h3>&euro;224M</h3>
                    <p>Оборот за 2023</p>
                </div>
            </div>
            <div class="info-circle info-circle-last">
                <div class="alcomet info-circle-icon">q</div>
                <svg width="164" height="164" xmlns="http://www.w3.org/2000/svg">
                    <g>
                    <rect fill="none" id="canvas_background" height="166" width="166" y="-1" x="-1"/>
                    <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
                    <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%" width="100%"/>
                    </g>
                    </g>
                    <g>
                    <path class="circle-path" id="svg_2" d="m7,82c0,-41.43646 33.56354,-75 75,-75c41.43646,0 75,33.56354 75,75c0,41.43646 -33.56354,75 -75,75c-41.43646,0 -75,-33.56354 -75,-75z" stroke-opacity="null" stroke-linecap="null" stroke-linejoin="null" stroke-width="14" stroke="rgb(51, 108, 157)" fill-opacity="null" fill="none"/>
                    </g>
                </svg>
                <div v-scroll-reveal class="info-circle-text">
                    <h3>95%</h3>
                    <p>Натовареност</p>
                </div>
            </div>
        </div>
        <div id="chartContainer1" class="chartst"></div>
        <div id="chartContainer2" class="chartst" ></div>

        <!--
        <h3>Продажби по страни за 2018г.</h3>
        <img class="graph-image" src="/static/img/about/kf/graph_1.svg" alt="Chart">
        -->
        <!-- <div class="chart-wrapper">
            <canvas class="chart" id="chartOne"></canvas>
        </div> -->
        <!--
        <h3>Широка гама от продукти</h3>
        <img class="graph-image" src="/static/img/about/kf/graph_2.svg" alt="Chart">
        -->
        <!-- <div class="geo-wrapper">
            <geo-chart :data="[
            ['Great Britain', 3.6],
            ['Netherlands', 3.4],
            ['Germany', 24.5],
            ['Poland', 12.5],
            ['Italy', 12.4],
            ['Bulgaria', 6.6],
            ['France', 6.6],
            ['Spain', 6.1],
            ['Austria', 4.4],
            ['Denmark', 4.3]
            ]"></geo-chart>
        </div>
        <div class="chart-wrapper">
            <canvas class="chart" id="chartTwo"></canvas>
        </div> -->
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import Chart from "chart.js";
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  },
  methods: {
    createChart(chartId, chartData, chartOptions) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: "doughnut",
        data: chartData,
        options: chartOptions
      });
    }
  },
  mounted() {
    const dataOne = {
      datasets: [
        {
          data: [3, 28, 3, 1, 11, 14, 6, 7, 27],
          backgroundColor: [
            "#ac6fc4",
            "#0095FE",
            "#00A9C2",
            "#00CFCD",
            "#8fe579",
            "#FFE1C2",
            "#FFC239",
            "#FF9145",
            "#FF2564"
          ]
        }
      ],
      labels: [
        "Drawing profiles",
        "Standart profiles",
        "Anodized profiles",
        "Painted profiles",
        "Sheets",
        "Strip",
        "Lubricated foil",
        "Technical foil",
        "HH foil"
      ]
    };
    const optionsOne = {
      legend: {
        position: "left"
      }
    };
    const dataTwo = {
      datasets: [
        {
          data: [3.6, 3.4, 24.5, 12.5, 12.4, 6.6, 6.6, 6.1, 4.4, 4.3, 15.6],
          backgroundColor: [
            "#a60bb7",
            "#ac6fc4",
            "#0095FE",
            "#00A9C2",
            "#00CFCD",
            "#8fe579",
            "#FFE1C2",
            "#FFC239",
            "#FF9145",
            "#FF2564",
            "#ff0000"
          ]
        }
      ],
      labels: [
        "Great Britain",
        "Netherlands",
        "Germany",
        "Poland",
        "Italy",
        "Bulgaria",
        "France",
        "Spain",
        "Austria",
        "Denmark",
        "Others"
      ]
    };
    const optionsTwo = {
      legend: {
        position: "right"
      }
    };
    // this.createChart("chartOne", dataOne, optionsOne);
    // this.createChart("chartTwo", dataTwo, optionsTwo);

      var chart = new CanvasJS.Chart("chartContainer1", {
          animationEnabled: true,
          title:{
              text: "Top 10 countries by sales in MT for Alcomet AD, 2022",
              horizontalAlign: "center",
              fontColor: "#004787"
          },
          data: [{
              type: "doughnut",
              startAngle: 60,
              innerRadius: 100,
              indexLabelFontSize: 17,
              indexLabelFontColor: "#004787",
              indexLabel: "{label} - #percent%",
              toolTipContent: "<b>{label}:</b> (#percent%)",
              dataPoints: [
                { y: 20.2, label: "Германия" },
                { y: 16.4, label: "Полша" },
                { y: 14.4, label: "Италия" },
                { y: 9.4, label: "Испания" },
                { y: 7.4, label: "Нидерландия" },
                { y: 4.9, label: "САЩ" },
                { y: 4.6, label: "България" },
                { y: 3.7, label: "Франция" },
                { y: 3.2, label: "Белгия" },
                { y: 2.9, label: "Австрия" },
                { y: 12.9, label: "Други" }
              ]
          }]
      });
      chart.render();

      var chart1 = new CanvasJS.Chart("chartContainer2", {
          animationEnabled: true,
          title:{
              text: "Продажби по видове продукти 2022",
              horizontalAlign: "center",
              fontColor: "#004787"
          },
          data: [{
              type: "doughnut",
              startAngle: 60,
              innerRadius: 100,
              indexLabelFontSize: 19,
              indexLabelFontColor: "#004787",
              indexLabel: "{label} - #percent%",
              toolTipContent: "<b>{label}:</b>  (#percent%)",
              dataPoints: [
                { y: 15.89, label: "Специални профили" },
                { y: 23.05, label: "Стандартни профили" },
                { y: 3.39, label: "Елоксирани профили"},
                { y: 1.07, label: "Боядисани профили"},
                { y: 6.35, label: "Листа"},
                { y: 12.19, label: "Ленти"},
                { y: 7.81, label: "Обмазано фолио"},
                { y: 4.16, label: "Техническо фолио"},
                { y: 21.15, label: "Домакинско фолио" },
                { y: 1.15, label: "Фолио за конвертиране"},
                { y: 3.77, label: "Финсток"}
              ]
          }]
      });
      chart1.render();

  }
};
</script>

<style scoped>
.about-kf {
  align-items: center;
  padding: 40px 40px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.about-kf > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.info-circles {
  display: flex;
  margin: 15px 0;
  justify-content: space-around;
}
.info-circle {
  align-content: center;
  background-color: #e9f2fa;
  border: 13px solid #f7fafd;
  border-radius: 50%;
  display: flex;
  height: 220px;
  justify-content: center;
  margin: 10px 35px;
  padding: 13px;
  position: relative;
  width: 220px;
}
.info-circle > svg {
  transform: rotate(-140deg);
}
.circle-path {
  stroke-dasharray: 300, 515;
  animation: load 10s linear infinite;
}
.chartst { margin-top:100px; height: 600px; width: 100%;}
@keyframes load {
  50% {
    stroke-dasharray: 280, 515;
    stroke: #1a437c;
  }
  100% {
    stroke-dasharray: 300, 515;
    stroke: #336c9d;
  }
}
.info-circle-icon {
  bottom: -10px;
  color: #bac6d7;
  font-size: 50px;
  position: absolute;
  right: -10px;
}
.info-circle-text {
  display: flex;
  flex-direction: column;
  left: 60px;
  position: absolute;
  top: 65px;
  width: 300px;
}
.info-circle-text > h3 {
  color: #1a437c;
  font-size: 40px;
  font-weight: 300;
}
.info-circle-text > h3 > sup {
  font-size: 20px;
  font-weight: 700;
}
.info-circle-text > p {
  color: #336c9d;
  font-size: 12px;
  margin: 0;
  line-height: initial;
  padding-left: 6px;
}
.about-kf > h3 {
  font-size: 19px;
  margin: 50px 0;
}
.chart-wrapper {
  height: auto;
  margin: 20px 0;
  width: 60%;
}
.graph-image {
  height: auto;
  width: 60%;
}
.geo-wrapper {
  height: auto;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1280px) {
  .info-circles {
    justify-content: center;
    width: 100%;
  }
  .info-circle {
    height: 200px;
    margin: 10px;
    width: 200px;
  }
  .info-circle svg {
    display: none;
  }
  .info-circle-text {
    align-items: center;
    justify-content: center;
    position: static;
  }
  .info-circle-text > h3 {
    font-size: 22px;
    text-align: center;
  }
  .info-circle-text > h3 > sup {
    font-size: 14px;
  }
  .info-circle-text > p {
    font-size: 12px;
    margin: 0;
    padding: 0;
    text-align: center;
  }
}
@media screen and (max-width: 1000px) {
  .about-kf {
    padding: 0;
  }
  .about-kf p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .info-circle-text > p {
    font-size: 12px;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .graph-image {
    padding: 0 30px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .info-circle {
    height: 160px;
    width: 160px;
  }
  .info-circle-text > h3 {
    font-size: 16px;
  }
  .info-circle-text > h3 > sup {
    font-size: 14px;
  }
}
@media screen and (max-width: 600px) {
  .info-circles {
    /* flex-direction: column; */
  }
  .info-circle {
    align-items: center;
    border: none;
    border-radius: 0;
    background-color: transparent;
    flex-direction: column;
    height: initial;
    justify-content: center;
    margin: 10px 0;
    width: calc(33.33% - 20px);
  }
  .info-circle-icon {
    font-size: 80px;
    margin-bottom: 5px;
    position: static;
  }
  .info-circle-text {
    width: initial;
  }
  .info-circle-text > h3 {
    font-size: 16px;
    white-space: nowrap;
  }
  .info-circle-text > h3 > sup {
    font-size: 10px;
  }
  .info-circle-text > p {
    white-space: nowrap;
  }
}
@media screen and (max-width: 440px) {
  .info-circle-icon {
    font-size: 50px;
  }
  .info-circle-text > p {
    font-size: 10px;
  }
  .info-circle-last {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/KeyFigures.vue